"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppBaseOwnRowChangeError = exports.APP_BASE_OWN_ROW_SIGN_IN_REQUIRED = exports.APP_BASE_OWN_ROW_INPUT_INVALID = exports.APP_BASE_OWN_ROW_NOT_FOUND = void 0;
exports.readAppBaseOwnRowChangeInput = readAppBaseOwnRowChangeInput;
const app_action_validation_1 = require("./app-action-validation");
/**
 * The answers of an ownRowChange action. A foreign row and a missing row get
 * the same one, so a portal person learns nothing about rows of others.
 */
exports.APP_BASE_OWN_ROW_NOT_FOUND = 'APP_BASE_OWN_ROW_NOT_FOUND';
/** The call names no row, or sends fields the action does not declare. */
exports.APP_BASE_OWN_ROW_INPUT_INVALID = 'APP_BASE_OWN_ROW_INPUT_INVALID';
/** Only a signed-in portal person changes own rows; a visitor never does. */
exports.APP_BASE_OWN_ROW_SIGN_IN_REQUIRED = 'APP_BASE_OWN_ROW_SIGN_IN_REQUIRED';
class AppBaseOwnRowChangeError extends Error {
    constructor(code, message = code) {
        super(message);
        this.code = code;
        this.name = 'AppBaseOwnRowChangeError';
    }
}
exports.AppBaseOwnRowChangeError = AppBaseOwnRowChangeError;
const MAX_ROW_ID_LENGTH = 256;
/**
 * Reads the call of an ownRowChange action: the row it names and, for an
 * update, the declared fields it sends. Fields the call leaves out keep their
 * cells. The platform and the StreamKit both read a call with this function;
 * whether the row is the caller's own is decided by the writer.
 *
 * Throws AppBaseOwnRowChangeError for a call that does not fit the action
 * and AppActionFieldValidationError for a field value that does not fit its
 * field.
 */
function readAppBaseOwnRowChangeInput(action, payload) {
    const { rowId } = payload;
    if (typeof rowId !== 'string' ||
        rowId.trim() === '' ||
        rowId.length > MAX_ROW_ID_LENGTH)
        throw new AppBaseOwnRowChangeError(exports.APP_BASE_OWN_ROW_INPUT_INVALID, `App Module action ${action.id} needs the id of the row it changes`);
    const fields = payload.fields ?? {};
    if (typeof fields !== 'object' || fields === null || Array.isArray(fields))
        throw new AppBaseOwnRowChangeError(exports.APP_BASE_OWN_ROW_INPUT_INVALID, `App Module action ${action.id} takes its fields as an object`);
    const sent = fields;
    const declared = new Set(action.fields.map(field => field.columnId));
    const undeclared = Object.keys(sent).filter(key => !declared.has(key));
    if (undeclared.length > 0)
        throw new AppBaseOwnRowChangeError(exports.APP_BASE_OWN_ROW_INPUT_INVALID, `App Module action ${action.id} does not declare the field(s) ${undeclared.join(', ')}`);
    if (action.operation === 'delete')
        return { rowId, values: {} };
    const changed = action.fields.filter(field => Object.prototype.hasOwnProperty.call(sent, field.columnId));
    if (changed.length === 0)
        throw new AppBaseOwnRowChangeError(exports.APP_BASE_OWN_ROW_INPUT_INVALID, `App Module action ${action.id} needs at least one field to change`);
    const values = (0, app_action_validation_1.validateAndSanitizeAppActionFields)(sent, changed.map(field => ({
        columnId: field.columnId,
        label: field.label,
        type: field.type,
        validation: { required: field.required, maxLength: field.maxLength },
        options: field.options,
    })));
    return { rowId, values };
}
